export default __webpack_public_path__ + "static/media/Blog.1780a256.png";